export const DEFAULT_SIZE = '1em';
